import { render, staticRenderFns } from "./CheckQuestion.vue?vue&type=template&id=a94cd4de&"
import script from "./CheckQuestion.vue?vue&type=script&lang=js&"
export * from "./CheckQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports